
import { useState } from "react";
import { Contact } from "./contacts/types";
import { SortField, SortOrder, ViewMode, CandidatesViewOptions } from "@/components/candidates/CandidatesViewOptions";
import { ContactsHeader } from "./contacts/ContactsHeader";
import { ContactsSearch } from "./contacts/ContactsSearch";
import { ContactsContent } from "./contacts/ContactsContent";

interface CompanyContactsTabProps {
  contacts: Contact[];
  loading: boolean;
  searchTerm: string;
  setSearchTerm: (value: string) => void;
  viewMode: ViewMode;
  setViewMode: (value: ViewMode) => void;
  companyId: string;
  onAddContact: () => void;
  refreshContacts: () => void;
}

export const CompanyContactsTab = ({
  contacts,
  loading,
  searchTerm,
  setSearchTerm,
  viewMode,
  setViewMode,
  companyId,
  onAddContact,
  refreshContacts
}: CompanyContactsTabProps) => {
  // These are dummy state handlers since this component doesn't currently use sorting
  // In a real implementation, we'd lift this state up to the parent component
  const [sortField, setSortField] = useState<SortField>("name");
  const [sortOrder, setSortOrder] = useState<SortOrder>("asc");

  return (
    <div className="bg-white rounded-lg shadow">
      <div className="p-6">
        <ContactsHeader onAddContact={onAddContact} />
        
        <ContactsSearch 
          searchTerm={searchTerm} 
          setSearchTerm={setSearchTerm} 
        />
        
        <CandidatesViewOptions
          sortField={sortField}
          setSortField={setSortField}
          sortOrder={sortOrder}
          setSortOrder={setSortOrder}
          viewMode={viewMode}
          setViewMode={setViewMode as (mode: ViewMode) => void}
        />
        
        <ContactsContent 
          contacts={contacts}
          loading={loading}
          viewMode={viewMode}
          companyId={companyId}
          onAddContact={onAddContact}
          refreshContacts={refreshContacts}
        />
      </div>
    </div>
  );
};
